import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[customBadgeStyle]',
})
export class CustomBadgeStyleDirective implements AfterViewInit {
  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    // Poll until Shadow DOM is ready
    const root: ShadowRoot | null =
      this.host.nativeElement.querySelector('goa-badge')?.shadowRoot ?? null;

    if (!root) return;

    // Apply style
    setTimeout(() => {
      const content = root.querySelector('div.goa-badge-content');
      content?.setAttribute('style', 'font-weight: 700;');
    }, 0);
  }
}
